<ms-onboarding-tooltip
    *ngIf="showHelp"
    [showHelp]="showHelp"
    [message]="sitecoreEventDetails.eventDetails.EventSwitcherOnboarding"></ms-onboarding-tooltip>
